<template>
  <div class="container" style="width: 80%">
    <h1
      id="textpass"
      class="mb-12 h36-medium white--text"
      style="line-height: 96%"
    >
      {{ $t("homepage.new-password.left.subtitle") }}
    </h1>
    <v-row
      class="texticon"
      no-gutters
      align="center"
      justify="center"
      style="width: 100%"
    >
      <v-toolbar
        class="layout my-button-toolbar"
        flat
        style="background-color: transparent"
      >
        <v-btn
          class="importantbutton mr-3"
          fab
          small
          style="pointer-events: none"
        >
          <v-icon color="white">lock</v-icon>
        </v-btn>
        <v-toolbar-title
          style="line-height: 20px"
          class="my-v-toolbar__title-inherit body-2 white--text"
        >
          {{ $t("homepage.new-password.left.description") }}
        </v-toolbar-title>
      </v-toolbar>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {}
};
</script>

<style scoped>
@media screen and (max-width: 959px) and (min-width: 801px) {
  #textpass {
    line-height: 40px !important;
  }

  .container {
    width: 93% !important;
  }

  .texticon {
    padding-top: 15px !important;
    padding-bottom: 70px !important;
  }
}

@media only screen and (max-width: 800px) {
  #textpass {
    line-height: 40px !important;
  }

  .container {
    width: 93% !important;
  }

  .texticon {
    padding-top: 15px !important;
    padding-bottom: 50px !important;
  }
}

@media only screen and (max-width: 600px) {
  #textpass {
    line-height: 40px !important;
  }

  .container {
    width: 90% !important;
  }

  .texticon {
    padding-top: 15px !important;
    padding-bottom: 50px !important;
  }
}

@media only screen and (max-width: 480px) {
  #textpass {
    line-height: 40px !important;
  }

  .container {
    width: 85% !important;
  }

  .texticon {
    padding-top: 15px !important;
    padding-bottom: 50px !important;
  }
}

@media only screen and (max-width: 414px) {
  #textpass {
    line-height: 40px !important;
  }

  .container {
    width: 85% !important;
  }

  .texticon {
    padding-top: 15px !important;
    padding-bottom: 50px !important;
  }
}

@media only screen and (max-width: 412px) {
  #textpass {
    line-height: 40px !important;
  }

  .container {
    width: 88% !important;
  }

  .texticon {
    padding-top: 15px !important;
    padding-bottom: 50px !important;
  }
}

@media only screen and (max-width: 375px) {
  #textpass {
    line-height: 40px !important;
  }

  .container {
    width: 85% !important;
  }

  .texticon {
    padding-top: 30px !important;
    padding-bottom: 70px !important;
  }
}

@media screen and (max-width: 340px) and (min-width: 320px) {
  #textpass {
    line-height: 40px !important;
  }

  .container {
    width: 85% !important;
  }

  .texticon {
    padding-top: 60px !important;
    padding-bottom: 110px !important;
  }
}

@media screen and (max-width: 320px) and (min-width: 300px) {
  #textpass {
    line-height: 40px !important;
  }

  .container {
    width: 85% !important;
  }

  .texticon {
    padding-top: 70px !important;
    padding-bottom: 120px !important;
  }
}

@media screen and (max-width: 300px) and (min-width: 280px) {
  #textpass {
    line-height: 40px !important;
  }

  .container {
    width: 85% !important;
  }

  .texticon {
    padding-top: 80px !important;
    padding-bottom: 120px !important;
  }
}

@media screen and (max-width: 280px) and (min-width: 270px) {
  #textpass {
    line-height: 40px !important;
  }

  .container {
    width: 85% !important;
  }

  .texticon {
    padding-top: 60px !important;
    padding-bottom: 120px !important;
  }
}

@media screen and (max-width: 270px) and (min-width: 260px) {
  #textpass {
    line-height: 30px !important;
    font-size: 30px !important;
  }

  .container {
    width: 85% !important;
  }

  .texticon {
    padding-top: 80px !important;
    padding-bottom: 120px !important;
  }
}

@media screen and (max-width: 260px) and (min-width: 240px) {
  #textpass {
    line-height: 25px !important;
    font-size: 25px !important;
  }

  .container {
    width: 85% !important;
  }

  .texticon {
    padding-top: 140px !important;
    padding-bottom: 200px !important;
  }
}
</style>
